import { Types } from '@store/types';

const initialState = { selectedUsers: [], allMembers: [], isMy: false, isTeam: false };

const TeamMembersReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.IS_TEAM_REQUEST_SELECTED:
			return { ...state, isTeam: action.payload };
		case Types.IS_MY_REQUEST_SELECTED:
			return { ...state, isMy: action.payload };
		case Types.CLEAR_TEAM_FILTER:
			return { ...initialState };
		case Types.SELECT_TEAM_MEMBER: {
			let tmpSelectedUsers = [...state.selectedUsers];
			if (state.selectedUsers.find((item) => item.id === action.payload.id)) {
				tmpSelectedUsers = tmpSelectedUsers.filter((item) => item !== action.payload);
			} else {
				tmpSelectedUsers.push(action.payload);
			}
			return { ...state, selectedUsers: tmpSelectedUsers };
		}
		default:
			return state;
	}
};

export default TeamMembersReducer;
